export const trackWPH = (action: string, options?: Record<string, string>) => {
  if (typeof window.wph === 'function') {
    window.wph('track', action, options)
  }
}
